import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'me-container';

const DEFAULTS = {
  yGap: '5xl',
  yGapLg: '7xl',
} as const;

/**
 * A layout container component that provides optional vertical spacing.
 *
 * Used as a wrapper for content within layout sections (e.g., inside `<me-section>`).
 * Supports different spacing sizes and flexible root tag rendering.
 */
@Component({
  tag: 'me-container',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Container {
  /**
   * The HTML tag to use for the container element.
   * Defaults to `'div'`.
   */
  @Prop() tag: 'div' | 'section' = 'div';

  /**
   * Controls the amount of vertical spacing (padding) applied to the container.
   * A modifier class will be added if the value differs from the default (`large`).
   */
  @Prop() yGap: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' = DEFAULTS.yGap;
  @Prop() yGapLg: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' = DEFAULTS.yGapLg;

  render() {
    const Tag = this.tag;

    // Add modifier class
    const yGapClass = `${COMPONENT_NAME}--y-gap-${this.yGap}`;
    const yGapLgClass = `${COMPONENT_NAME}--y-gap-lg-${this.yGapLg}`;

    // Combine base and modifier class names
    const classList = [COMPONENT_NAME, yGapClass, yGapLgClass].filter(Boolean).join(' ');

    return (
      <Tag class={classList}>
        <slot></slot>
      </Tag>
    );
  }
}
